'use client';

import '@/styles/globals.css';
import '@/styles/globals.v2.css';

import { startTransition, useEffect } from 'react';

import ErrorPage from '@/components/ErrorPage';
import {
  CircularSpotifyText,
  CircularStdBookBlack,
  CircularStdBookBold,
  CircularStdBookMedium,
  CircularStdBookNormal,
  MontserratBold,
  MontserratLight,
  MontserratRegular,
} from '@/config/fonts';
import cn from '@/helpers/utils/classNames';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const handleReset = () => {
    startTransition(() => {
      reset();
      return window.location.reload();
    });
  };

  useEffect(() => {
    console.log(error, 'application error');
  }, [error]);

  window.location.reload();

  return (
    <html>
      <body
        className={cn(
          CircularStdBookNormal.variable,
          CircularStdBookMedium.variable,
          CircularStdBookBold.variable,
          CircularStdBookBlack.variable,
          CircularSpotifyText.variable,
          MontserratBold.variable,
          MontserratLight.variable,
          MontserratRegular.variable,
          'font-circular-std'
        )}
      >
        <ErrorPage onReset={handleReset} digest={error.digest ?? ''} />
      </body>
    </html>
  );
}
